module.exports = {"PROTECTIONS":{"TITLE":"Protect Your Investment","SUB_TITLE":"Before You Hit the Road","SELECT":"Select","SELECTED":"Selected","SELECTED_COUNT_1":"selected","SELECTED_COUNT":"selected","INCLUDED_COUNT":"(%{count} protections included)","DECLINED":"I Decline Protections","DECLINED_OPTION":"I Decline %{option}","DECLINE":"Decline Protections","DECLINE_OPTION":"Decline %{option}","BACK":"Back","DONE":"Done","MODIFY":"Modify","LEARN_MORE":"Learn More","LEARN_LESS":"See Less","VIEW_BROCHURE":"View Brochure","PRICE_ON_DEMAND":"Price on demand (we will contact you)"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = ./src/i18n/en.json
// module chunks = widget-6.25.3